import { getColumnsByNames } from './all-top10-columns-config';

export const topDestinationAllowedColumns = getColumnsByNames([
    { name: 'rule' },
    { name: 'dst' },
    { name: 'dport' },
    { name: 'proto' },
    { name: 'bytes', width: '34%' }
]);